<div class="ng-selected-filters-cont">
  <ng-content #selectedFilters></ng-content>
</div>
<div class="noResults__cont" [ngStyle]="{ 'padding-top': paddingTop }">
  <div class="noResults__cont__icon-container">
    <app-ds-icon
      [icon]="icons.Info"
      [size]="22"
      [color]="iconFillColor.Primary">
    </app-ds-icon>
  </div>
  <app-ds-typography
    [size]="fontSize.XXS"
    [color]="fontColor.Primary"
    [text]="!withMessage ? (translationError | transloco) : (messageError | transloco)">
  </app-ds-typography>
  <ng-container *ngIf="research">
    <div class="noResults__cont__button-container">
      <app-ds-button
        [buttonWidth]="buttonWidth"
        [labels]="{ ButtonLabel: translateRoot + '.RESEARCH' | transloco }"
        (clickEvent)="reload()">
      </app-ds-button>
    </div>
  </ng-container>
  <ng-container *ngIf="moreOptions">
    <div class="noResults__cont__button-container">
      <app-ds-button
        [buttonWidth]="buttonWidth"
        [labels]="{ ButtonLabel: translateRoot + '.VIEW_MORE_OPTIONS' | transloco }"
        (clickEvent)="showMoreOptions()">
      </app-ds-button>
    </div>
  </ng-container>
</div>
